module.exports = __webpack_public_path__ + "img/esmeralda-room-3.05a71b76.jpg";